import React from 'react';
import { useAuth } from '@/context/AuthContext';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { motion } from 'framer-motion';

const Dashboard: React.FC = () => {
  const { user } = useAuth();

  return (
    <div className="space-y-6 p-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h1 className="text-2xl font-bold text-gray-800">Welcome, {user?.full_name}</h1>
        <p className="text-gray-500">Your CDS attendance dashboard</p>
      </motion.div>

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        <Card>
          <CardHeader>
            <CardTitle>Upcoming Meetings</CardTitle>
            <CardDescription>Your next CDS meeting</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-gray-500">No upcoming meetings</p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Attendance Status</CardTitle>
            <CardDescription>Your current attendance record</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-gray-500">Loading attendance data...</p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Clearance Status</CardTitle>
            <CardDescription>Your clearance eligibility</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-gray-500">Checking eligibility...</p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Dashboard; 